export default __webpack_public_path__ + "static/media/ios_incoming_ring.aec62715.mp3";